import { withStyles } from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';

const RemoveZoomButtonCrabber = withStyles((theme) => ({
    root: {
        position: "absolute",
        color: "#AAAAAA",
        marginLeft: -18,
        padding: 0,
        marginTop: 91,
    }
}))(IconButton); 

export default RemoveZoomButtonCrabber;